import { EuiCallOut, EuiButton, EuiSpacer, EuiFlexGroup, EuiFlexItem, EuiTitle, EuiIcon } from '@elastic/eui'

export const InEditModeCalloutOld = ({ onExitEditModeClick, onResetClick }: { onExitEditModeClick: () => void; onResetClick: () => void }) => {
  const title = (
    <EuiFlexGroup gutterSize='xs' alignItems='center'>
      <EuiFlexItem grow={false}>
        <EuiIcon type='wrench' />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiTitle size='s'>
          <p>This Plan is in Edit Mode.</p>
        </EuiTitle>
      </EuiFlexItem>
    </EuiFlexGroup>
  )

  return (
    <EuiCallOut title={title} color='primary'>
      <EuiSpacer size='m' />
      <div style={{ paddingLeft: '24px' }}>
        You may edit the campaigns and summary paragraphs.
        <br />
        The Marketing Plan and Campaign Summary PDFs will automatically update based on your changes. The Market Analysis PDF will not change.
        <EuiSpacer size='m' />
        <EuiSpacer size='m' />
      </div>
      <EuiFlexGroup direction={'row'} justifyContent={'flexStart'}>
        <EuiFlexItem grow={false}>
          <EuiButton size='s' onClick={onExitEditModeClick} fill iconType={'returnKey'}>
            Exit Edit Mode
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem />
        <EuiFlexItem grow={false}>
          <EuiButton size='s' onClick={onResetClick} color='danger'>
            Reset All
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiCallOut>
  )
}
